export const telFormatRegex   = /^\d{10,11}$/;
export const emailFormatRegex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/; //参考URL：https://www.javadrive.jp/regex-basic/sample/index13.html
export const isRequired = ((label: string, inputType: 'text' | 'textarea' | 'checkbox' | 'radio' | 'select' = 'text', customErrorMessage?: string | null | undefined) => ((value: string) => {
  if (!!value && value != '') return true;
  if (!!customErrorMessage) return customErrorMessage.replaceAll("<<label>>", label)
  switch (inputType) {
    case 'select':
    case 'checkbox':
    case 'radio':
      return `${label}を選択してください。`;
    case 'text':
    case 'textarea':
    default:
      return `${label}をご入力ください。`;
  }
}));
export const isSutisfiedWithFormat = ((label: string, formatRegex: RegExp) => ((value: string) => !!formatRegex.test(value) || `${label}を正しく入力してください。`));
export const isEqualledWithItem = ((label: string, anotherItemModel: any, anotherItemLabel: string) => ((value: any) => (!!(value === anotherItemModel) || `${label}と${anotherItemLabel}が一致しません。（${label}：${value}、${anotherItemLabel}：${anotherItemModel}）`)));
